// モーダル表示・非表示
const colorModal = document.querySelector('.collection-color-modal');
const modalTriggers = document.querySelectorAll(
  '.collection-color-modal__overlay, .collection-color-modal__close, .card_color'
);

modalTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    if (colorModal.classList.contains('is-show')) {
      // モーダルを非表示にする場合
      colorModal.animate([{ opacity: '1' }, { opacity: '0' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      }).onfinish = () => {
        colorModal.style.display = 'none';
        colorModal.classList.toggle('is-show');
      };
    } else {
      // モーダルを表示する場合
      colorModal.style.opacity = 0;
      colorModal.style.display = 'flex';
      colorModal.classList.toggle('is-show');
      colorModal.animate([{ opacity: '0' }, { opacity: '1' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  });
});

// カラーコード選択時にモーダルの中身を作成
const colorBtn = document.querySelectorAll('.card_color');
const modalContent = document.querySelector('#colorImgContainer');

colorBtn.forEach(btn => {
  btn.addEventListener('click', () => {
    modalContent.innerHTML = '';
    const colorData = btn.querySelectorAll('li');
    colorData.forEach(color => {
      const field = document.createElement('li');
      const template = `
      <a href="${color.dataset.link}">
        <img src="${color.dataset.img}">
        <span>${color.dataset.name}</span>
      </a>
      `;
      field.innerHTML = template;
      modalContent.appendChild(field);
    });
  });
});

// 現在選択している表示方法を取得
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const currentView = urlParams.get('view');

// 表示方法選択時の処理
const colorChangeSelect = document.querySelector('#colorChange');

colorChangeSelect.addEventListener('change', event => {
  const selectedValue = event.target.value;
  if (selectedValue === '全色表示') {
    urlParams.set('view', 'all-color');
    const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
    window.location.href = newUrl;
  } else {
    urlParams.delete('view');
    const newUrl = `${window.location.origin}${window.location.pathname}`;
    window.location.href = newUrl;
  }
});

// 全色表示を選択時に、セレクトボックスの表示を変更
window.addEventListener('DOMContentLoaded', () => {
  if (currentView === 'all-color') {
    colorChangeSelect.value = '全色表示';
  }
});

// ドロワー表示・非表示
const filterDrawer = document.querySelector('.product-filter__drawer');
const drawerTriggers = document.querySelectorAll(
  '.product-filter__drawer__overlay, .product-filter__drawer__close, .product-filter__btn'
);
const filterDrawerContent = document.querySelector('.product-filter__drawer__content');

drawerTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    filterDrawer.classList.toggle('is-show');
    filterDrawerContent.classList.toggle('is-show');
    document.body.classList.toggle('drawer-open');
  });
});
